import {memo} from 'react'

import classes from "./SearchResultsCard.module.css";

import Modal from "../../UI/Modal";
import DrinksResults from "./DrinksResults/DrinksResults";

// component card for returned search results
const SearchResultsCard = (props) => {

  // all returned cocktails from search
  var drinks = props.drinks;

  // sort the drinks by the fraction of ingredients we have in cabinet already
  // if the fracton is the same, put in order of most ingrediets in cabinet
  drinks.sort((a, b) => {
    var frac_a = a.ingCount / a.ingredients.length;
    var frac_b = b.ingCount / b.ingredients.length;

    if (frac_a < frac_b) {
      return 1;
    }
    if (frac_a > frac_b) {
      return -1;
    }
    if (b.ingCount > a.ingCount) {
      return -1;
    }
    return 0;
  });

  return (
    <Modal onClose={props.onClose}>
      
      <div className={classes.search_results_card}>
        <div className={classes.header}>Cocktails</div>
        <div className={classes.body}>
          <DrinksResults drinks={drinks}/>
        </div>
      </div>
    </Modal>
  );
};

export default memo(SearchResultsCard);
